export const pageVariants = {
  initial: {
    opacity: 0,
    y: 50,
    scale: 0.99,
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  exit: {
    opacity: 0,
    y: -90,
    scale: 0.99,
  },
};

export const pageTransition = {
  duration: 0.4,
  ease: "easeOut",
};